var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-menu sub-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/cases"}},[_vm._v("Cases")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }